<template>
  <v-img
    :src="src"
    :class="{
      'p-gallery__exhibitBlock': true,
      'img-hover-background': hover,
    }"
    :style="{
      width: width,
      height: height,
      maxHeight: height,
      maxWidth: width,
      paddingBottom: paddingBottom,
    }"
  >
    <slot />
  </v-img>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    hover: {
      type: Boolean,
      required: false,
      default: false
    },
    width: {
      type: String,
      required: false,
      default: '250px'
    },
    height: {
      type: String,
      required: false,
      default: '250px'
    },
    paddingBottom: {
      type: String,
      required: false,
      default: '0'
    }
  }
}
</script>

<style scoped lang="sass">
.img-hover-background
  position: relative
  &::before
    content: ''
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    background: black
    opacity: 0.5
.p-gallery
  &__exhibitBlock
    object-fit: cover
</style>
